import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { teamStore } from 'state/team/team'
import MemberForm from './ModalContent/MemberForm'

interface ManageMemberProps {
  teamId: string
  organizationId: string
  refetch: () => void
}

const ManageMember: React.FC<ManageMemberProps> = ({ teamId, organizationId, refetch }) => {
  const { memberModalVisible, setMemberModalVisible } = teamStore(store => ({
    memberModalVisible: store.memberModalVisible,
    setMemberModalVisible: store.setMemberModalVisible,
  }))

  return (
    <CustomModal
      openModal={memberModalVisible}
      closeModal={setMemberModalVisible}
      title="Add Member"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Close"
          onSubmit={() => setMemberModalVisible(false)}
        />
      }
    >
      <MemberForm teamId={teamId} organizationId={organizationId} onSuccess={refetch} />
    </CustomModal>
  )
}

export default ManageMember
